import React from 'react'
import '../App.css';
import { useState } from 'react';


function Header() {
    const [mobileMenu, setMobileMenu] = useState(false);
    function handleMobileMenu() {
        setMobileMenu(!mobileMenu); 
    }
  return (
    <div>
        <div className='navbar lg:py-4 py-3 lg:px-10 px-4'>
            <div className='flex items-center justify-between'>
                <div className="logo">
                    <img src={`${process.env.PUBLIC_URL}/bulb-logo.png`} alt="logo"  className='w-28'/>
                </div>
                <a onClick={handleMobileMenu} className="ham-icon lg:hidden block">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 18L20 18" stroke="#EB4F23" stroke-width="2" stroke-linecap="round"></path> <path d="M4 12L20 12" stroke="#EB4F23" stroke-width="2" stroke-linecap="round"></path> <path d="M4 6L20 6" stroke="#EB4F23" stroke-width="2" stroke-linecap="round"></path> </g>
                    </svg>
                </a>
                <ul className='nav-menu gap-4 lg:flex hidden'>
                    <li>
                        <a href="" className='text-[#EB4F23]'>Home</a>
                    </li>
                    <li>
                        <a href="" className='hover:text-[#EB4F23]'>LED Lighting</a>
                    </li>
                    <li>
                        <a href="" className='hover:text-[#EB4F23]'>Whole House Package</a>
                    </li>
                    <li>
                        <a href="" className='hover:text-[#EB4F23]'>Lighting</a>
                    </li>
                    <li> 
                        <a href="" className='hover:text-[#EB4F23]'>About Us</a>
                    </li>
                    <li>
                        <a href="" className='hover:text-[#EB4F23]'>Contact Us</a>
                    </li>
                </ul>
                <ul className=' gap-4 lg:flex hidden'>
                    <li>
                        <a href=""><img src={`${process.env.PUBLIC_URL}/search.png`} alt="search" className='w-8'/></a></li>
                    <li>
                        <a href=""><img src={`${process.env.PUBLIC_URL}/basket.png`} alt="basket" className='w-8'/></a>
                    </li>
                    <li>
                        <a href=""><img src={`${process.env.PUBLIC_URL}/user.png`} alt="user" className='w-8'/></a>
                    </li>
                </ul>
            </div>
        </div>
        <div className={`absolute z-10 right-2 bg-white py-4 px-6 rounded-b-lg ${mobileMenu ? 'block' : 'hidden'}`}>
                    <ul className='nav-menu flex flex-col gap-2'>
                        <li>
                            <a href="" className='text-[#EB4F23]'>Home</a>
                        </li>
                        <li>
                            <a href="" className='hover:text-[#EB4F23]'>LED Lighting</a>
                        </li>
                        <li>
                            <a href="" className='hover:text-[#EB4F23]'>Whole House Package</a>
                        </li>
                        <li>
                            <a href="" className='hover:text-[#EB4F23]'>Lighting</a>
                        </li>
                        <li> 
                            <a href="" className='hover:text-[#EB4F23]'>About Us</a>
                        </li>
                        <li>
                            <a href="" className='hover:text-[#EB4F23]'>Contact Us</a>
                        </li>
                        <ul className='flex gap-2'>
                        <li>
                            <a href=""><img src={`${process.env.PUBLIC_URL}/search.png`} alt="search" className='w-6'/></a></li>
                        <li>
                            <a href=""><img src={`${process.env.PUBLIC_URL}/basket.png`} alt="basket" className='w-6'/></a>
                        </li>
                        <li>
                            <a href=""><img src={`${process.env.PUBLIC_URL}/user.png`} alt="user" className='w-6'/></a>
                        </li>
                    </ul>
                    </ul>
        </div>
    </div>
  )
}

export default Header;


